import React, { forwardRef, useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { colors } from "../../constants/colors";
import Typography from "@mui/material/Typography";
import propTypes from "prop-types";
import { border } from "@mui/system";
import { images } from "../../Images/Svg";
import { ApprovalInvestigationMainTabs } from "../../constants/approvalsData";
import { Skeleton } from "@mui/material";
import { disableSecondTabVal } from "../../constants/caseManagementData";
import { useSelector } from "react-redux";
const { redColorDownArrow } = images;

const tabPillBackgroundColors = [
  "#FFF4eb",
  "#F9F5FF",
  "#F7FDFA",
  "#FFFCF0",
  "#FEF5F8",
  "#F1F2FF",
  "#E6F8FE",
];
const tabPillColors = [
  "#fe9551",
  "#A760FF",
  "#59CE8F",
  "#FBCB0A",
  "#F56D91",
  "#396AF2",
  "#28C3D8",
];
const activeTabBgColor = [
  "#ff9551",
  "#a55ffc",
  "#59ce8f",
  "#fbcb0c",
  "#f56d91",
  "#396af2",
  "#25c3d8",
];
const vendorTabStyles = [
  {
    label: "rejected",
    color: "#991F01",
    bgColor: "#FFD6CC",
    border: "1px solid #991F01",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    padding: "0.8rem 3rem",
  },
  {
    label: "reinvestigated",
    color: "#991F01",
    bgColor: "#FFD6CC",
    border: "1px solid #991F01",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    padding: "0.8rem 3rem",
  },
  {
    label: "approved",
    color: "#0C7436",
    bgColor: "#C5F5D9",
    border: "1px solid #0C7436",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    padding: "0.8rem 3rem",
  },
  {
    label: "pending",
    color: "#3A3A3A",
    bgColor: "#FFFFFF",
    border: "1px solid #3A3A3A",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    padding: "0.8rem 3rem",
  },
  {
    label: "review",
    color: "#3A3A3A",
    bgColor: "#FFFFFF",
    border: "1px solid #3A3A3A",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    padding: "0.8rem 3rem",
  },
];

// const investigationFirstTab = [
//   {
//     label: "Vendor & Blocks",
//     border: "1px solid #90949A",
//     activeBorderColor: "1px solid #E8505B",
//   },
//   {
//     label: "Investigation Reports",
//     border: "1px solid #90949A",
//     activeBorderColor: "1px solid #E8505B",
//   },
//   {
//     label: "Invoice",
//     border: "1px solid #90949A",
//     activeBorderColor: "1px solid #E8505B",
//   },
// ];

// variant pill, gray, grayShadow, standard
const MuiTab = forwardRef(
  (
    {
      indicatorColor = "#E7373B",
      onClick = () => {},
      variant = "pill",
      tabs = [],
      gap = "8px",
      activeTab = 0,
      setActiveTab = () => {},
      fontSize = "13px",
      padding = 1.5,
      popupType,
      type,
    },
    ref
  ) => {
    const [tabValue, setTabValue] = useState(activeTab || 0);
    const tabRef = useRef(null);
    const { searchSource, searchValue, searchType } = useSelector(
      (state) => state.SearchSlice
    );
    const handleChange = (event, newValue) => {
      if (
        searchSource === "Cima" &&
        disableSecondTabVal?.includes(event?.target?.innerText) &&
        searchValue &&
        searchType
      ) {
        return;
      }
      let invoiceStatus = event?.target?.dataset?.invoice_status;
      let investigationStatus = event?.target?.dataset?.investigation_status;
      setTabValue(newValue);
      setActiveTab(newValue);
      onClick(event, newValue, invoiceStatus, investigationStatus);
    };
    const getStyle = (index, item) => {
      const variantTypes = {
        pill: {
          color: tabValue === index ? "white" : tabPillColors[index],
          backgroundColor:
            tabValue === index
              ? type === "createCase"
                ? activeTabBgColor[index + 1]
                : activeTabBgColor[index]
              : tabPillBackgroundColors[index],
          boxShadow:
            tabValue === index
              ? type === "createCase"
                ? `0px 3px 10px 0px ${activeTabBgColor[index + 1]}`
                : `0px 3px 10px 0px ${activeTabBgColor[index]}`
              : "none",
          textTransform: "none",
          fontWeight: tabValue === index ? 700 : 500,
          fontSize: fontSize,
          padding: 1.5,
          borderRadius: "4px",
        },
        standard: {
          color:
            tabValue === index
              ? item?.border
                ? "white"
                : indicatorColor
              : disableSecondTabVal?.includes(item?.label) &&
                searchSource === "Cima" &&
                searchValue &&
                searchType
              ? "grey"
              : colors?.black,
          textTransform: "none",
          fontWeight: tabValue === index ? 700 : 500,
          fontSize: fontSize,
          padding: 1,
          border: item?.border || "",
          borderRadius: item?.border ? "4px" : "",
          backgroundColor: tabValue === index ? item?.bg || "" : "",
        },
        gray: {
          color: tabValue === index ? indicatorColor : colors?.gray2,
          textTransform: "none",
          fontWeight: tabValue === index ? 700 : 500,
          fontSize: fontSize,
          padding: "9px 12px 9px 12px !important",
          border:
            tabValue === index ? "1px solid #E8505B" : "1px solid #90949A",
          borderRadius: "4px",
        },
        grayShadow: {
          color: tabValue === index ? indicatorColor : "black",
          backgroundColor: tabValue === index ? "#FEF5F8" : "white",
          textTransform: "none",
          fontWeight: tabValue === index ? 700 : 500,
          fontSize: fontSize,
          padding: 1.5,
          border:
            tabValue === index ? "1px solid transparent" : "1px solid #90949A",
          borderRadius: "4px",
          boxShadow:
            tabValue === index ? "0px 2px 4px rgba(232, 80, 91, 0.5)" : "none",
        },
        boxed: {
          color: tabValue === index ? indicatorColor : colors?.black2,
          textTransform: "none",
          fontWeight: tabValue === index ? 700 : 500,
          fontSize: 11,
          border:
            tabValue === index ? "1px solid #E8505B" : "1px solid #90949A",
          borderRadius: "4px",
        },
      };
      return variantTypes[variant];
    };
    const getStyleTabIndicator = () => {
      let variantTypes = {
        pill: {
          backgroundColor: "transparent",
          width: 0,
          height: 0,
        },
        standard: {
          backgroundColor: indicatorColor,
          // height: tabs[0]?.label === "Investigation" && !tabValue ? 0 : 2,
          height: tabs[tabValue]?.label === "Investigation" ? 0 : 2,
          top: "57px",
        },
        gray: {
          backgroundColor: indicatorColor,
          width: 0,
          height: 0,
        },
      };
      return variantTypes[variant];
    };

    const boxedAssessmentStyle = () => {
      return variant === "boxed"
        ? {
            border: "1px solid #90949A",
          }
        : {};
    };
    const getVendorTabStyles = (index) => {
      const {
        investigationStatus,
        invoice_status: invoiceStatus,
        activeTab,
        isActive,
      } = tabs[index];

      let status =
        activeTab === ApprovalInvestigationMainTabs[1]?.label
          ? investigationStatus
          : activeTab === ApprovalInvestigationMainTabs[2]?.label
          ? invoiceStatus
          : activeTab === ApprovalInvestigationMainTabs[0]?.label
          ? investigationStatus
          : "pending";
      if (!isActive && activeTab !== ApprovalInvestigationMainTabs[2]?.label) {
        status = "rejected";
      }
      if (variant === "boxed") {
        status = investigationStatus;
      }
      const vendor = vendorTabStyles.find((vendor) => vendor.label === status);
      const color = vendor?.color;
      const bgColor = vendor?.bgColor;
      const border =
        tabValue === index
          ? vendor?.border
          : status === "pending" || status === "review"
          ? " 1px solid #90949A"
          : "none";
      const boxShadow = tabValue === index ? vendor?.boxShadow : "";
      const padding = vendor?.padding;

      const tabStyles = {};
      if (color) {
        tabStyles.color = color;
      }
      if (bgColor) {
        tabStyles.backgroundColor = bgColor;
      }
      if (border) {
        tabStyles.border = border;
      }
      if (boxShadow) {
        tabStyles.boxShadow = boxShadow;
      }
      if (padding) {
        tabStyles.padding = padding;
      }

      return tabStyles;
    };

    // const getVendorInvestigationFirstTabStyle = (item, index) => {
    //   const investigationFirstTabStyle = investigationFirstTab.find(
    //     (tab) => tab.label === item.label
    //   );
    //   const isActiveTab = tabValue === index; // Check if the tab is active
    //   const border = isActiveTab
    //     ? investigationFirstTabStyle?.activeBorderColor || ""
    //     : investigationFirstTabStyle?.border || "";

    //   return { border }; // Merge the styles
    // };
    useEffect(() => {
      setTimeout(() => {
        tabRef?.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }, 350);
    }, []);

    useEffect(() => {
      setTabValue(activeTab);
    }, [activeTab]);

    return (
      <Box sx={{ width: "100%" }} ref={ref}>
        <Box
          ref={tabRef}
          sx={{
            display: "flex",
            gap: "1.6rem",
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleChange}
            aria-label="tabs-label"
            indicatorColor={indicatorColor}
            TabIndicatorProps={{
              style: getStyleTabIndicator(),
            }}
            variant={variant === "boxed" ? "standard" : "scrollable"}
            sx={
              variant === "boxed" || popupType === "manual"
                ? {
                    "& .MuiTabs-flexContainer": {
                      flexWrap: "wrap",
                    },
                  }
                : variant === "standard"
                ? {
                    width: "100%",
                    "& .MuiTabs-flexContainer": {
                      justifyContent: "space-between",
                    },
                  }
                : null
            }
            scrollButtons={false}
          >
            {(!tabs?.length ? Array(5)?.fill({ label: 0 }) : tabs)?.map(
              (item, index) => {
                return (
                  <Tab
                    id={index}
                    sx={{
                      border: 0,
                      padding:
                        popupType === "manual"
                          ? `0 0 12px 0`
                          : variant === "boxed"
                          ? "7px 5px"
                          : `12px ${gap} 12px 16px`,
                      cursor:
                        searchSource === "Cima" &&
                        disableSecondTabVal?.includes(item?.label) &&
                        searchValue &&
                        searchType
                          ? "not-allowed"
                          : "pointer",
                    }}
                    key={item?.label + index}
                    disableRipple
                    icon={item?.icon}
                    iconPosition="end"
                    data-invoice_status={item?.invoice_status}
                    data-investigation_status={item?.investigationStatus}
                    label={
                      <Typography
                        sx={{
                          width: popupType === "manual" ? "8.5rem" : "unset",
                          padding,
                          fontFamily: "Inter",
                          ...getStyle(index, item),
                          ...(tabs[index]?.investigationStatus ||
                          tabs[index]?.invoice_status
                            ? getVendorTabStyles(index)
                            : ""),
                          ...boxedAssessmentStyle(),
                        }}
                        data-invoice_status={item?.invoice_status}
                        data-investigation_status={item?.investigationStatus}
                      >
                        {item?.label || (
                          <Skeleton animation="wave" width="8.5rem" />
                        )}
                      </Typography>
                    }
                  ></Tab>
                );
              }
            )}
          </Tabs>
        </Box>
      </Box>
    );
  }
);

MuiTab.propTypes = {
  indicatorColor: propTypes.string,
  onClick: propTypes.func,
  tabs: propTypes.array,
  variant: propTypes.string,
  gap: propTypes.string,
  activeTab: propTypes.number,
};

export default MuiTab;
